'use strict';
module.exports = function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1;
};


//////////////////
// WEBPACK FOOTER
// /~/dom-helpers/class/hasClass.js
// module id = 1207
// module chunks = 0